import React, { useState, useEffect } from 'react';
import { 
  Users, Search, Loader2, GraduationCap, Phone
} from 'lucide-react';
import { studentPanelAPI } from '../../services/api';

const StudentGroupmates = () => {
  const [group, setGroup] = useState(null);
  const [groupmates, setGroupmates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchGroupmates();
  }, []);

  const fetchGroupmates = async () => {
    try {
      const response = await studentPanelAPI.getGroupmates();
      setGroup(response.data.group);
      setGroupmates(response.data.groupmates || []);
    } catch (error) {
      console.error('Guruh a\'zolarini yuklashda xato:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredGroupmates = groupmates.filter(student => {
    const fullName = `${student.user.last_name} ${student.user.first_name}`.toLowerCase();
    return fullName.includes(searchTerm.toLowerCase());
  });

  if (loading) {
    return (
      <div className="loading-container">
        <Loader2 className="spinner" size={40} />
        <p>Yuklanmoqda...</p>
      </div>
    );
  }

  if (!group) {
    return (
      <div className="page-container">
        <div className="empty-state">
          <Users size={48} />
          <p>Guruh biriktirilmagan</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <header className="page-header">
        <div className="page-title">
          <h1><Users size={28} /> {group.name}</h1>
          <p>{group.course}-kurs • {groupmates.length + 1} talaba</p>
        </div>
      </header>

      {/* Search */}
      <div className="search-bar">
        <Search size={20} />
        <input 
          type="text" 
          placeholder="Talabani qidirish..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Groupmates Grid */}
      {filteredGroupmates.length === 0 ? (
        <div className="empty-state">
          <Users size={48} />
          <p>Guruhda boshqa talabalar yo'q</p>
        </div>
      ) : (
        <div className="groupmates-grid">
          {filteredGroupmates.map(student => (
            <div key={student.id} className="groupmate-card">
              <div className="groupmate-avatar">
                {student.user.first_name?.[0]}{student.user.last_name?.[0]}
              </div>
              <div className="groupmate-info">
                <h3>{student.user.full_name}</h3>
                <div className="groupmate-details">
                  <span className="student-id-badge">
                    <GraduationCap size={14} />
                    {student.student_id}
                  </span>
                  {student.user.phone && (
                    <span className="phone-badge">
                      <Phone size={14} />
                      {student.user.phone}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentGroupmates;
